import { render, staticRenderFns } from "./OrganigramaMuniView.vue?vue&type=template&id=714267f4&"
import script from "./OrganigramaMuniView.vue?vue&type=script&lang=ts&"
export * from "./OrganigramaMuniView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports